import React from 'react';
import { Query } from 'react-apollo';
import { FormControl } from 'react-bootstrap';
import gql from 'graphql-tag';

const accountInfoListQuery = gql`
  query CustomerImportProduct($customer_service_type: String) {
    accountInfoList(customer_service_type: $customer_service_type) {
      account_info {
        _id
        account_info_business_name
        billing_customer_id
      }
    }
  }
`;

const SelectCustomer = ({ value, onChange, selectLabel }) => {
  const label = selectLabel || 'เลือกลูกค้า';

  return (
    <Query
      query={accountInfoListQuery}
      variables={{
        customer_service_type: 'PARCEL',
        showData: 1000,
      }}
      fetchPolicy="cache-and-network"
    >
      {({ data, loading, error }) => {
        return (
          <FormControl
            componentClass="select"
            placeholder="select"
            value={value}
            onChange={onChange}
            disabled={error || loading}
          >
            <option value="">{loading ? 'กำลังโหลด...' : label}</option>
            {!loading &&
              !error &&
              data.accountInfoList.account_info.map(item => (
                <option key={item._id} value={item.billing_customer_id}>
                  {item.account_info_business_name}
                </option>
              ))}
          </FormControl>
        );
      }}
    </Query>
  );
};

export default SelectCustomer;
